const keys = {
  receipt: {
    coverages: {
      core: {
        deductible: 'Deductible',
        included: 'Included',
        notInclude: 'Not included',
      },
      aboveGroundWater: {
        title: 'Above ground water damage',
      },
      accidentBenefits_34: {
        title: 'Accident benefits (QEF 34)',
      },
      additionnalLivingCost: {
        title: 'Additional living cost',
      },
      bettermentsAndImprovements: {
        title: 'Betterments and improvements',
      },
      burglary: {
        title: 'Theft and burglary',
      },
      caregiver: {
        title: 'Caregiver Benefits',
        value: {
          included: 'Extended',
          notIncluded: 'Base',
        },
      },
      changeToDeductible_41: {
        title: {
          on: 'Change to deductible (OPCF 41)',
          qc: 'Change to deductible (QEF 41)',
        },
      },
      collision_b2: {
        title: {
          on: 'Collision (your fault)',
          qc: 'Collision and upset (Section B2)',
        },
      },
      collisionNotFault: {
        title: 'Collision (not your fault)',
      },
      comprehensive_b3: {
        title: {
          on: 'Comprehensive',
          qc: 'Comprehensive (Section B3)',
        },
      },
      contingencyLiability: {
        title: 'Unit contingency',
      },
      deductible: {
        title: 'Deductible',
      },
      dependentCare: {
        title: 'Dependant Care Benefits',
      },
      detachedStructures: {
        title: 'Detached Structures',
      },
      earthquakes: {
        title: 'Earthquakes',
      },
      familyProtection: {
        title: 'Family protection (OPCF 44)',
      },
      fire: {
        title: 'Fire and smoke',
      },
      fireAfterEarthquake: {
        title: 'Fire after an earthquake',
      },
      funeral: {
        title: 'Funeral and Death Benefits',
        value: {
          included: 'Extended',
          notIncluded: 'Base',
        },
      },
      house: {
        title: 'House',
      },
      identityTheft: {
        title: 'Identity theft',
      },
      incomeReplacement: {
        title: 'Income replacement benefits',
        value: {
          notIncluded: '$ 400',
        },
      },
      indexation: {
        title: 'Indexation Benefits',
      },
      liabilityNonOwnedVehicle_2: {
        title: 'Non-owned vehicles (QEF 2)',
      },
      lossAssessmentLiability: {
        title: 'Loss assessment liability',
      },
      lossAssessmentProperty: {
        title: 'Loss assessment property',
      },
      medicalCatastrophicInjury: {
        title: 'Medical Benefits (Catastrophic injury)',
        value: {
          included: 'Extended',
          notIncluded: 'Base',
        },
      },
      medicalExpenses: {
        title: 'Medical expenses',
      },
      medicalNonCatastrophicInjury: {
        title: 'Medical Benefits (Non catastrophic injury)',
        value: {
          notIncluded: '$ 65,000',
        },
      },

      nonOwnedVehicle_27: {
        title: {
          on: 'Rented or borrowed vehicles (OPCF 27)',
          qc: 'Rented or borrowed vehicles (QEF 27)',
        },
      },
      personalLiability: {
        title: 'Personal liability',
      },
      personalProperty: {
        title: 'Personal property',
      },
      pool: {
        title: 'Pool',
      },
      spa: {
        title: 'Spa',
      },
      rentOrLeased: { title: { on: 'Rented or leased vehicles (OPCF 5)', qc: 'Rented or leased vehicles (QEF 5a)' } },
      replacementCarValue_43ae: {
        title: {
          on: 'Replacement cost (OPCF 43)',
          qc: 'Replacement Cost (QEF 43A-E)',
        },
      },
      roadAssistance_33: {
        title: {
          on: 'Roadside assistance (OPCF 35)',
          qc: 'Roadside assistance (QEF 33)',
        },
      },
      thirdLiability_a: {
        title: {
          on: 'Civil liability',
          qc: 'Civil liability (Section A)',
        },
      },
      travelCosts_20a: {
        title: {
          qc: 'Travel costs (QEF 20)',
          on: 'Travel costs (OPCF 20)',
        },
      },
      uninsuredAutomobile: {
        title: 'Uninsured automobile',
      },
      voluntaryProperty: {
        title: 'Voluntary property',
      },
      waterEntry: {
        title: 'Water Service Pipe Breakage',
      },
      waterPackage: {
        title: 'Overland water / sewer backup damage',
      },
      wind: {
        title: 'Wind',
      },
    },
    sections: {
      floaters: 'High value belongings coverages',
      primaryCoverages: 'Primary coverages',
      secondaryCoverages: 'Additional coverages',
      ternaryCoverages: 'Accident benefits',
    },
    billing: {
      frequency: {
        annually: {
          name: 'Annually',
          paymentsCount: 'One payment of',
        },
        monthly: {
          name: 'Monthly',
          paymentsCount: 'Monthly payments of',
        },
      },
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
